<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">{{ schemeType === 'tdf' ? 'Technology Product Prototype' : 'Development of Prototype' }}</h4>
        <h5 class="text-primary">[{{ proposalName}}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>
      <div class="action-buttons">
        <!-- <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->
        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>
        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <div class="mb-10 mt-8 transition-all duration-200 hover:shadow-md">
    <div class="divide-y divide-gray-200">
      <form [formGroup]="challengeForm">
        <div *ngIf="schemeType === 'revenue'"
          class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
          <div (click)="isSectionOpen.prototypeScheduleDetails = !isSectionOpen.prototypeScheduleDetails"
            class="flex items-center justify-between p-4 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
            <h3 class="text-lg font-semibold flex items-center">
              <span
                class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-sm">
                <i class="pi pi-calendar"></i>
              </span>
              Prototype Schedule Details
            </h3>
            <i class="pi transition-transform duration-200"
              [ngClass]="isSectionOpen.prototypeScheduleDetails ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </div>
          <div *ngIf="isSectionOpen.prototypeScheduleDetails"
            class="p-6 space-y-4 border-t border-slate-100 animate-fade-in">
            <div class="mb-4">
              <label for="deliveryDate" class="block bg-blue-500 text-white font-medium p-2 mb-1 rounded">
                <strong>Prototype Delivery Date</strong>
              </label>
              <input type="date" id="deliveryDate"
                class="form-control border-2 border-blue-200 rounded px-2 py-1 w-full max-w-sm"
                formControlName="deliveryDate">
            </div>
            <div class="mb-1">
              <label for="prototypeDate" class="block bg-blue-500 text-white font-medium p-2 mb-1 rounded">
                <strong>Installation/Commission Date</strong>
              </label>
              <input type="date" id="prototypeDate"
                class="form-control border-2 border-blue-200 rounded px-2 py-1 w-full max-w-sm"
                formControlName="prototypeDate">
            </div>
            <div class="mb-1">
              <label for="prototypeDate" class="block bg-blue-500 text-white font-medium p-2 mb-1 rounded">
                <strong>Location Of Delivery</strong>
              </label>
              <input type="text" id="delivery_location"
                class="form-control border-2 border-blue-200 rounded px-2 py-1 w-full max-w-sm"
                formControlName="delivery_location">
            </div>
          </div>
        </div>
        <ng-container *ngFor="let row of shortlistedvendor; let i = index">
          <div>
            <div
              class="flex items-center justify-between p-4 my-3 cursor-pointer bg-gray-300/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
              (click)="sectionToggles(row)">
              <div class="flex items-center">
                <span
                  class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-base font-bold">
                  {{ row.vendor_name?.charAt(0) || '-' }}
                </span>
                <span class="font-semibold text-lg">
                  {{ row.vendor_name || '-' }}
                </span>
              </div>
              <i class="pi transition-transform duration-200"
                [ngClass]="row.isSectionOpen ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </div>
            <div [hidden]="!row.isSectionOpen" class="p-1 space-y-2 border-t border-slate-100 animate-fade-in">
              <div class="bg-white rounded-lg shadow-sm p-1 border border-gray-200 mx-auto max-w-7xl">
                <div *ngIf="schemeType == 'tdf'">
                  <span class="p-card">{{shortlistedvendor?.vendor_name}}</span>
                </div>
                <ng-container *ngIf="schemeType != 'revenue'">
                  <div class="border rounded bg-amber-50 mb-4 mt-2 px-2 py-3">
                    <div class="grid grid-cols-2 gap-2">
                      <div class="form-group editor-container flex flex-col col-span-2 mb-2">
                        <p class="bg-blue-500 font-semibold text-blue-700 mb-1 text-bold text-white p-2 ">Project Definition</p>
                        <editor [init]="init" formControlName="projectDefinition" [disabled]="isEditorDisabled">
                        </editor>
                      </div>
                      <div class="form-group editor-container flex flex-col col-span-2 mb-2">
                        <p class="bg-blue-500 font-semibold text-blue-700 mb-1 text-bold text-white p-2 ">Preliminary Design</p>
                        <editor [init]="init" formControlName="preliminaryDesign" [disabled]="isEditorDisabled">
                        </editor>
                      </div>
                      <div class="form-group editor-container flex flex-col col-span-2 mb-2">
                        <p class="bg-blue-500 font-semibold text-blue-700 mb-1 text-bold text-white p-2 ">Detailed Design</p>
                        <editor [init]="init" formControlName="detailedDesign" [disabled]="isEditorDisabled"></editor>
                      </div>
                      <div class="form-group editor-container flex flex-col col-span-2 mb-2">
                        <p class="bg-blue-500 font-semibold text-blue-700 mb-1 text-bold text-white p-2 ">Fabrication/Development Benefits</p>
                        <editor [init]="init" formControlName="fabricationBenefits" [disabled]="isEditorDisabled">
                        </editor>
                      </div>
                      <div class="form-group editor-container flex flex-col col-span-2 mb-2">
                        <p class="bg-blue-500 font-semibold text-blue-700 mb-1 text-bold text-white p-2 ">Test and Analysis</p>
                        <editor [init]="init" formControlName="testAnalysis" [disabled]="isEditorDisabled"></editor>
                      </div>
                      <div class="form-group editor-container flex flex-col col-span-2 mb-2">
                        <p class="bg-blue-500 font-semibold text-blue-700 mb-1 text-bold text-white p-2 ">Integration</p>
                        <editor [init]="init" formControlName="integration" [disabled]="isEditorDisabled"></editor>
                      </div>
                      <div class="form-group editor-container flex flex-col mb-2 col-span-2">
                        <p class="bg-blue-500 font-semibold text-blue-700 mb-1 text-bold text-white p-2 ">Performance Evaluation</p>
                        <editor [init]="init" formControlName="performanceEvaluation" [disabled]="isEditorDisabled">
                        </editor>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
  </div>

  <hr class="my-3" />
  <div class="row mb-4">
    <app-upload-document [title]="stepDetails.name+' Document'"
      [isEditable]="stepDetails?.can_edit"></app-upload-document>
  </div>
</div>